module.exports = __webpack_public_path__ + "img/summary_pv.58e9e71c.svg";